import { render, staticRenderFns } from "./PhotoBookPage.vue?vue&type=template&id=ef1f4d9c&scoped=true"
import script from "./PhotoBookPage.vue?vue&type=script&lang=js"
export * from "./PhotoBookPage.vue?vue&type=script&lang=js"
import style0 from "./PhotoBookPage.vue?vue&type=style&index=0&id=ef1f4d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1f4d9c",
  null
  
)

export default component.exports